import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { isLoggedInUser } from '../../../../utils/isLoggedInUser';
import { MP_CLICKED_CONTACT_ME } from '../../../../utils/mixPanelEvents';
import { BQ_CLICKED_CONTACT_SELLER } from '../../../../utils/bigQueryEvents';
import { JS_JOIN_HOOK } from '../../../../utils/constants';

import './style.scss';

class ContactMe extends Component {

    constructor() {
        super();

        this.onContactClick = this.onContactClick.bind(this);
    }

    onContactClick() {
        const { biEvents } = this.context;

        biEvents.sendMixPanelEvent({
            eventName: MP_CLICKED_CONTACT_ME,
            params: { 'Source component': 'Gig page seller card' }
        });

        biEvents.sendBigQueryEvent({
            eventName: BQ_CLICKED_CONTACT_SELLER,
            params: { name: 'about_the_seller' }
        });
    }

    shouldShowContact() {
        const { isOnVacation } = this.context.general;

        return !isOnVacation;
    }

    render() {
        const { pathfinderWrapper, requestContext, general } = this.context;
        const { is_mobile: isMobile, current_user: currentUser, params } = requestContext;
        const contactLink = pathfinderWrapper.pathfinder('conversation', { id: params.username });

        if (!this.shouldShowContact()) {
            return null;
        }

        const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREY;
        let btnClasses = classnames('btn-contact-me');
        if (!isMobile) {
            // TODO: "js-contact-me" is referenced in v2 (inside "popup-first-message.js"), needs to be updated

            btnClasses = classnames(btnClasses, 'js-contact-me', {
                [JS_JOIN_HOOK]: !isLoggedInUser(currentUser)
            });
        }

        return (
            <>
                <Button href={contactLink}
                    className={btnClasses}
                    onClick={this.onContactClick}
                    color={btnColor}
                    fill={Button.FILLS.GHOST}>
                    <I18n k={'gig_page_perseus.seller_card.contact_me'}/>
                </Button>
                <div id="react-first-message-popup"/>
            </>
        );
    }
}

ContactMe.contextTypes = {
    requestContext: PropTypes.object,
    biEvents: PropTypes.object,
    pathfinderWrapper: PropTypes.object,
    general: PropTypes.object
};

export default ContactMe;
